import CachedIcon from "@mui/icons-material/Cached";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const DEFAULT_MESSAGE =
  "Unable to reach the server. Please check your connection and try again.";

interface BootstrapErrorScreenProps {
  message?: string;
  onRetry: () => void;
}

// ENG-1745: rendered by <Layout /> in place of the app shell once the /me
// bootstrap fetch has failed and no user has ever loaded. Previously nothing
// filled this gap — the shell rendered against the pre-auth placeholder user,
// which read to the customer as an indefinite spinner while every
// user-dependent query on the page stayed unresolved. `onRetry` triggers an
// immediate in-place retry; no page reload is required or implied.
export default function BootstrapErrorScreen({
  message,
  onRetry
}: BootstrapErrorScreenProps) {
  return (
    <Stack
      data-testid="bootstrap-error-screen"
      alignItems="center"
      justifyContent="center"
      gap={3}
      sx={{ width: "100vw", height: "100vh", textAlign: "center", px: 3 }}
    >
      <WifiOffIcon color="disabled" sx={{ fontSize: 56 }} />
      <Box maxWidth={420}>
        <Typography variant="h6" gutterBottom>
          Connection problem
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {message || DEFAULT_MESSAGE}
        </Typography>
      </Box>
      <Button variant="contained" startIcon={<CachedIcon />} onClick={onRetry}>
        Retry
      </Button>
    </Stack>
  );
}
